module.exports = __webpack_public_path__ + "img/sadist_of_notre_dame_desk.da877cf5.jpg";